/*eslint-disable*/
import React, { useEffect, useState, useContext } from "react";
import db from "../db"

// reactstrap components

// core components
import Clients from "../components/Admin/Clients/Clients"
import WhiteNavbar from "../components/Navbars/WhiteNavbar";
import { LoadingScreen } from "../components/MiscFunctions"

function ClientsPage() {
    document.documentElement.classList.remove("nav-open");

    const [partners, setPartners] = useState([])
    useEffect(() => db.OurPartners.listenAll(setPartners), [])

    return (
        <div style={{ minHeight: "100vh" }} className="section-dark">
            {
                !partners || partners && partners.length > 0 ?
                    <>
                        <WhiteNavbar />
                        <Clients size="4" partners={partners} />
                    </>
                    :
                    <LoadingScreen />

            }
        </div>
    );
}

export default ClientsPage;
